export enum VariableSettingsAction {
  CREATE = 'create',
  EDIT = 'edit',
  TEST = 'test',
  STATS = 'stats',
  VALIDATE = 'validate',
  CANARY = 'canary',
  EDIT_DELETE_AND_ARCHIVE = 'edit-delete-and-archive',
  VALIDATE_DELETE_AND_ARCHIVE = 'validate-delete-and-archive',
}

export enum ProductEntityAction {
  CREATE_MANAGE_ENTITIES = 'create-variable-manage-entities',
  CREATE_CREATE_ENTITY = 'create-variable-create-entity',
  CREATE_DELETE_ENTITY = 'create-variable-delete-entity',
  MANAGE_ENTITIES = 'manage-entities',
  CREATE_ENTITY = 'create-entity',
  DELETE_ENTITY = 'delete-entity',
}
